













import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'; // デコレータ
import { loadingControlModule } from '../../store/modules/LoadingControl'; // モジュール

@Component
export default class LoadingComponent extends Vue {
  get loading() {
    return loadingControlModule.GET_LOADING;
  }
}
